// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type DeleteScimTokenMutationVariables = PrivateSchemaTypes.Exact<{
  tokenId: PrivateSchemaTypes.Scalars['PositiveInt'];
  archiveResources?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
}>;


export type DeleteScimTokenMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisationToken?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationTokenModelMutations' }
      & Pick<PrivateSchemaTypes.OrganisationTokenModelMutations, 'delete'>
    )> }
  )> }
);

export type SetScimArchiveOnDeactivateMutationVariables = PrivateSchemaTypes.Exact<{
  value: PrivateSchemaTypes.Scalars['Boolean'];
}>;


export type SetScimArchiveOnDeactivateMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & { setScimArchiveOnDeactivate?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'OrganisationModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id' | 'scim_archive_on_deactivate'>
      )> }
    )> }
  )> }
);

export type FetchOrganisationTokensQueryVariables = PrivateSchemaTypes.Exact<{
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.OrganisationTokenModelFilterInput> | PrivateSchemaTypes.OrganisationTokenModelFilterInput>;
}>;


export type FetchOrganisationTokensQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id' | 'scim_archive_on_deactivate'>
      & { organisationTokens: Array<(
        { __typename?: 'OrganisationTokenModel' }
        & Pick<PrivateSchemaTypes.OrganisationTokenModel, 'id' | 'token' | 'privileges' | 'created_at' | 'deleted_at' | 'scimResourcesCount'>
      )> }
    )> }
  )> }
);

export type CreateOrganisationTokenMutationVariables = PrivateSchemaTypes.Exact<{
  privileges: Array<PrivateSchemaTypes.OrganisationTokenPrivilege> | PrivateSchemaTypes.OrganisationTokenPrivilege;
}>;


export type CreateOrganisationTokenMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'id'>
      & { createOrganisationToken?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'OrganisationTokenModel' }
        & Pick<PrivateSchemaTypes.OrganisationTokenModel, 'id'>
      )> }
    )> }
  )> }
);


export const DeleteScimTokenDocument = gql`
    mutation deleteScimToken($tokenId: PositiveInt!, $archiveResources: Boolean) {
  admin {
    organisationToken(id: $tokenId) {
      delete(archiveResources: $archiveResources)
    }
  }
}
    `;
export type DeleteScimTokenMutationFn = Apollo.MutationFunction<DeleteScimTokenMutation, DeleteScimTokenMutationVariables>;

/**
 * __useDeleteScimTokenMutation__
 *
 * To run a mutation, you first call `useDeleteScimTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScimTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScimTokenMutation, { data, loading, error }] = useDeleteScimTokenMutation({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *      archiveResources: // value for 'archiveResources'
 *   },
 * });
 */
export function useDeleteScimTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteScimTokenMutation, DeleteScimTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteScimTokenMutation, DeleteScimTokenMutationVariables>(DeleteScimTokenDocument, options);
      }
export type DeleteScimTokenMutationHookResult = ReturnType<typeof useDeleteScimTokenMutation>;
export type DeleteScimTokenMutationResult = Apollo.MutationResult<DeleteScimTokenMutation>;
export type DeleteScimTokenMutationOptions = Apollo.BaseMutationOptions<DeleteScimTokenMutation, DeleteScimTokenMutationVariables>;
export const SetScimArchiveOnDeactivateDocument = gql`
    mutation setScimArchiveOnDeactivate($value: Boolean!) {
  admin {
    organisation {
      setScimArchiveOnDeactivate(value: $value) {
        id
        scim_archive_on_deactivate
      }
    }
  }
}
    `;
export type SetScimArchiveOnDeactivateMutationFn = Apollo.MutationFunction<SetScimArchiveOnDeactivateMutation, SetScimArchiveOnDeactivateMutationVariables>;

/**
 * __useSetScimArchiveOnDeactivateMutation__
 *
 * To run a mutation, you first call `useSetScimArchiveOnDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetScimArchiveOnDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setScimArchiveOnDeactivateMutation, { data, loading, error }] = useSetScimArchiveOnDeactivateMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetScimArchiveOnDeactivateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetScimArchiveOnDeactivateMutation, SetScimArchiveOnDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetScimArchiveOnDeactivateMutation, SetScimArchiveOnDeactivateMutationVariables>(SetScimArchiveOnDeactivateDocument, options);
      }
export type SetScimArchiveOnDeactivateMutationHookResult = ReturnType<typeof useSetScimArchiveOnDeactivateMutation>;
export type SetScimArchiveOnDeactivateMutationResult = Apollo.MutationResult<SetScimArchiveOnDeactivateMutation>;
export type SetScimArchiveOnDeactivateMutationOptions = Apollo.BaseMutationOptions<SetScimArchiveOnDeactivateMutation, SetScimArchiveOnDeactivateMutationVariables>;
export const FetchOrganisationTokensDocument = gql`
    query fetchOrganisationTokens($filters: [OrganisationTokenModelFilterInput!]) {
  admin {
    organisation {
      id
      scim_archive_on_deactivate
      organisationTokens(filters: $filters, order: {name: "id"}) {
        id
        token
        privileges
        created_at
        deleted_at
        scimResourcesCount
      }
    }
  }
}
    `;

/**
 * __useFetchOrganisationTokensQuery__
 *
 * To run a query within a React component, call `useFetchOrganisationTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrganisationTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrganisationTokensQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchOrganisationTokensQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchOrganisationTokensQuery, FetchOrganisationTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchOrganisationTokensQuery, FetchOrganisationTokensQueryVariables>(FetchOrganisationTokensDocument, options);
      }
export function useFetchOrganisationTokensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchOrganisationTokensQuery, FetchOrganisationTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchOrganisationTokensQuery, FetchOrganisationTokensQueryVariables>(FetchOrganisationTokensDocument, options);
        }
export type FetchOrganisationTokensQueryHookResult = ReturnType<typeof useFetchOrganisationTokensQuery>;
export type FetchOrganisationTokensLazyQueryHookResult = ReturnType<typeof useFetchOrganisationTokensLazyQuery>;
export type FetchOrganisationTokensQueryResult = Apollo.QueryResult<FetchOrganisationTokensQuery, FetchOrganisationTokensQueryVariables>;
export const CreateOrganisationTokenDocument = gql`
    mutation createOrganisationToken($privileges: [OrganisationTokenPrivilege!]!) {
  admin {
    organisation {
      id
      createOrganisationToken(privileges: $privileges) {
        id
      }
    }
  }
}
    `;
export type CreateOrganisationTokenMutationFn = Apollo.MutationFunction<CreateOrganisationTokenMutation, CreateOrganisationTokenMutationVariables>;

/**
 * __useCreateOrganisationTokenMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationTokenMutation, { data, loading, error }] = useCreateOrganisationTokenMutation({
 *   variables: {
 *      privileges: // value for 'privileges'
 *   },
 * });
 */
export function useCreateOrganisationTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrganisationTokenMutation, CreateOrganisationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrganisationTokenMutation, CreateOrganisationTokenMutationVariables>(CreateOrganisationTokenDocument, options);
      }
export type CreateOrganisationTokenMutationHookResult = ReturnType<typeof useCreateOrganisationTokenMutation>;
export type CreateOrganisationTokenMutationResult = Apollo.MutationResult<CreateOrganisationTokenMutation>;
export type CreateOrganisationTokenMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationTokenMutation, CreateOrganisationTokenMutationVariables>;